import MaskToggle from './MaskToggle';
import { createPortal } from 'react-dom';
import { X, Calculator } from 'lucide-react';
import { pitOverview, layerName, f2 } from '../lib/excavation';
import { eur } from '../lib/license';
import VatRows from './VatRows';

const mt = (r, locale) => (r ? `${f2(r.m3, locale)} m³ / ${f2(r.t, locale)} t` : '–');

export default function PitCostDialog({ t, project, pits, onClose }) {
  const ov = pitOverview(pits, project.reports);
  return createPortal(
    <div className="editor-backdrop" data-testid="pit-cost-dialog">
      <div className="editor pit-cost mask">
        <div className="editor-head mask-keep">
          <h4><Calculator size={18} /> {t.pitCostTitle}</h4>
          <MaskToggle t={t} id="pit-cost" /><button className="icon-btn" data-testid="pit-cost-close-btn" onClick={onClose}><X size={16} /></button>
        </div>
        <div className="pit-cost-sub">{project.title} · {ov.rows.length} {t.pitCount}</div>
        {!ov.priced && <div className="empty" data-testid="pit-cost-noprice">{t.pitNoPrice}</div>}
        <div className="gen-table-wrap">
          <table className="mat-table" data-testid="pit-cost-table">
            <thead><tr><th>{t.pitCount}</th><th>{t.reports}</th><th>m²</th><th>{t.pitColExcav}</th><th>{t.pitColSand}</th><th>{t.pitColGravel}</th><th>{t.pitColSurface}</th><th>{t.pitColCost}</th></tr></thead>
            <tbody>
              {ov.rows.map((r, i) => (
                <tr key={r.p.id} data-testid={`pit-cost-row-${i}`}>
                  <td>{r.p.name}</td><td>{r.rep}</td><td>{f2(r.c.area, t.locale)}</td><td>{f2(r.c.excav.m3, t.locale)}</td>
                  <td>{mt(r.sand, t.locale)}</td><td>{mt(r.fill, t.locale)}</td><td>{r.surf ? `${f2(r.c.area, t.locale)} m²` : '–'}</td>
                  <td data-testid={`pit-cost-row-total-${i}`}>{eur(r.c.total, t.locale)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <b className="mat-sub">{t.pitByMat}</b>
        <table className="mat-table" data-testid="pit-cost-mats">
          <thead><tr><th>{t.pitColLayer}</th><th>m³</th><th>t</th><th>{t.pitColCost}</th></tr></thead>
          <tbody>
            {Object.values(ov.tot.mats).map(({ row, m3, t: tn, cost }) => (
              <tr key={row.name || row.key}><td>{layerName(t, row)}</td><td>{f2(m3, t.locale)}</td><td>{f2(tn, t.locale)}</td><td>{eur(cost, t.locale)}</td></tr>
            ))}
            <tr><td>{t.pitL_excav}</td><td>{f2(ov.tot.excav, t.locale)}</td><td /><td>{eur(ov.tot.excavCost, t.locale)}</td></tr>
          </tbody>
          <tfoot><VatRows t={t} net={ov.tot.cost} span={3} testid="pit-cost" /></tfoot>
        </table>
      </div>
    </div>,
    document.body,
  );
}
